import { render, staticRenderFns } from "./updataModal.vue?vue&type=template&id=a9109e3e&"
import script from "./updataModal.vue?vue&type=script&lang=js&"
export * from "./updataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports